import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';

import { ContentType } from '@candu-ai/content/types';
import { setForceSnapshotCookie } from '@candu-ai/extension/journey';
import { useAuthentication, useLocalStorage, useNavigation } from 'commons/hooks';
import { View } from 'dashboard/components/View';
import { useExtensionInstallationState } from 'dashboard/containers/ExtensionStateProvider';
import { CONTENT_PATH, contentPath } from 'dashboard/pages/Content/constants';
import { CREATE_ROUTE } from 'dashboard/pages/Content/pages/Create/constants';

import { SnapshotState } from './constants';
import { Extension, Location, TakeSnapshot } from './states';

export const Snapshot = () => {
  const params = useParams();
  const contentId = params.contentId as string;
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const contentType = searchParams.get('contentType') as ContentType;
  const { applicationId } = useAuthentication();
  const { hasInstalledChromeExtension } = useExtensionInstallationState();

  const navigate = useNavigation();
  const [, setAddSnapshotModalCount] = useLocalStorage('candu.snapshots.addSnapshotModalCount');
  const [currentState, setCurrentState] = useState<SnapshotState>('Location');
  const [url, setUrl] = useState('');

  if (!contentId) {
    navigate(`${CONTENT_PATH}/${CREATE_ROUTE.path}`);
  }

  const allowSkip = contentType !== ContentType.HotspotGroup && contentType !== ContentType.Tour;

  const onSkip = () => {
    setAddSnapshotModalCount(3);
    navigate(contentPath(contentId));
  };

  const onComplete = () => {
    if (!applicationId) {
      return;
    }
    setForceSnapshotCookie({ url, contentId, applicationId });
    window.location.href = url;
  };

  useEffect(() => {
    if (currentState === 'Extension' && hasInstalledChromeExtension) {
      setCurrentState('TakeSnapshot');
    } else if (currentState === 'TakeSnapshot' && !hasInstalledChromeExtension) {
      setCurrentState('Extension');
    }
  }, [hasInstalledChromeExtension, currentState]);

  return (
    <View>
      <Helmet title="Create Content - Snapshot | Candu" />
      {((state: SnapshotState) => {
        switch (state) {
          case 'Location':
          default:
            return (
              <Location
                setCurrentState={setCurrentState}
                setUrl={setUrl}
                onSkip={allowSkip ? onSkip : undefined}
              />
            );
          case 'Extension':
            return (
              <Extension
                setCurrentState={setCurrentState}
                onSkip={allowSkip ? onSkip : undefined}
              />
            );
          case 'TakeSnapshot':
            return (
              <TakeSnapshot
                setCurrentState={setCurrentState}
                onSkip={allowSkip ? onSkip : undefined}
                onComplete={onComplete}
              />
            );
        }
      })(currentState)}
    </View>
  );
};

export default Snapshot;
